import { createContext } from 'react';

import type { InternalBlogPostItem } from 'components/molecules/JournalGroup';

export const MarketingPageContext = createContext<{
  internalBlogPosts: Array<InternalBlogPostItem>;
}>({
  internalBlogPosts: [],
});
